import {
    Callout,
    ColorPicker,
    DefaultButton,
    DelayedRender,
    IColor,
    IconButton,
    Label,
    mergeStyleSets,
    Modal,
    PrimaryButton,
    Stack,
    Text
} from '@fluentui/react';
import { IC } from 'components/SVGIcon';
import { QuestionCircle } from 'kits/IconKit2';
import IvicosStrings from 'kits/language/stringKit';
import React from 'react';
import { IvicosColors } from 'kits/colorKit';

interface IColorSelectorViewProps {
    label?: string;
    value: string;
    showModal: () => void;
    isModalOpen: boolean;
    smallDevice: boolean;
    toggleIsCalloutVisible: () => void;
    isCalloutVisible: boolean;
    colorSelectorWidth: string;
    buttonId: string;
    directionalHint: 12;
    callout?: string;
    width: string;
    height: string;
    onDismiss: () => void;
    colorChange: (ev: any, colorObj: IColor) => any;
}

const ColorSelectorView: React.FC<IColorSelectorViewProps> = (props) => {
    const {
        label,
        value,
        showModal,
        isModalOpen,
        smallDevice,
        toggleIsCalloutVisible,
        isCalloutVisible,
        colorSelectorWidth,
        buttonId,
        directionalHint,
        callout,
        width,
        height,
        onDismiss,
        colorChange
    } = props;

    const styles = mergeStyleSets({
        button: {
            width: 130
        },
        callout: {
            width: 320,
            padding: '20px 24px'
        }
    });

    return (
        <Stack>
            {label && <Label>{label}</Label>}
            <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 32 }}>
                <Stack style={{ width: '100%' }}>
                    <Stack horizontal={!smallDevice}>
                        <Stack
                            style={{
                                backgroundColor: value != '' ? value : IvicosColors.Mittelblau,
                                color: value != '' ? value : IvicosColors.Mittelblau,
                                width: width,
                                height: height
                            }}
                            className={colorSelectorWidth}
                            onClick={showModal}
                        ></Stack>
                        {!smallDevice && (
                            <IC variant="custom" size={15} style={{ cursor: 'pointer' }}>
                                <QuestionCircle onClick={toggleIsCalloutVisible} id={buttonId} />
                            </IC>
                        )}
                    </Stack>
                    {isCalloutVisible && !smallDevice && (
                        <Callout
                            className={styles.callout}
                            onDismiss={toggleIsCalloutVisible}
                            role="status"
                            target={`#${buttonId}`}
                            aria-live="assertive"
                            directionalHint={directionalHint}
                        >
                            <DelayedRender>
                                <Text variant="small">{callout}</Text>
                            </DelayedRender>
                        </Callout>
                    )}
                    <Stack horizontalAlign="center" style={smallDevice ? { width: '100%' } : { width: 400 }}>
                        <Text>{value != '' ? value.toUpperCase() : IvicosColors.Mittelblau.toUpperCase()}</Text>
                    </Stack>
                </Stack>
                {!smallDevice && (
                    <Stack style={{ width: 209 }}>
                        <DefaultButton onClick={showModal} iconProps={{ iconName: 'edit' }} text={IvicosStrings.changeColorActionTitle}></DefaultButton>
                    </Stack>
                )}
            </Stack>

            <Modal isOpen={isModalOpen} onDismiss={onDismiss} isBlocking={false}>
                <Stack horizontal horizontalAlign="end" aria-label="closing-color-picker">
                    <IconButton iconProps={{ iconName: 'cancel' }} ariaLabel="Close popup modal" onClick={onDismiss} />
                </Stack>
                <Stack aria-label="grabbing-color-picker">
                    {' '}
                    <ColorPicker color={value != '' ? value : IvicosColors.Mittelblau} onChange={colorChange} showPreview={true} />
                </Stack>

                <Stack style={{ alignItems: 'center', paddingBottom: 10 }}>
                    <PrimaryButton text={IvicosStrings.confirmActionTitle} onClick={onDismiss} />
                </Stack>
            </Modal>
        </Stack>
    );
};

export default ColorSelectorView;
